import { persist} from '@/assets/js/util.js'

const data = {
    url: '/',
    drawer: false,
    drawerPOS: false,
    loading: true,
    activeItem: {},
    menuCategory: "",
    strains: [],
    isExpanded: false
}

const context = persist('app', data)

export default context
